import React from 'react';

import { ModalDefault } from '../../../../components/ModalDefault/ModalDefault';
import { Loading } from '../../../../components/Loading/Loading';
import { useGetTgMessagesQuery } from '../../../../redux/services/TgSessionsApi';
import { type TgSession } from '../../../../redux/types/TgSessionsTypes';
import { formatDate, outcomeLabel } from './helpers';
import styles from '../TgSessions.module.css';

interface MessagesModalProps {
  active: boolean;
  setActive: (value: boolean) => void;
  session: TgSession;
}

const MessagesModal = ({ active, setActive, session }: MessagesModalProps) => {
  const { data, isLoading } = useGetTgMessagesQuery(session.id, { refetchOnMountOrArgChange: true });
  return (
    <ModalDefault title={`Последние сообщения · ${session.label || session.phone}`} titleMargin={'16px'} active={active} setActive={setActive} windowStyle={{ maxWidth: '640px', width: '100%' }}>
      {isLoading ? (
        <Loading />
      ) : !data || data.length === 0 ? (
        <div className={styles.empty}>Сообщений пока нет</div>
      ) : (
        <div className={styles.messages}>
          {data.map((message) => (
            <div key={message.id} className={styles.message}>
              <div className={styles.messageMeta}>
                <span>{message.sender_username ? `@${message.sender_username}` : message.chat_title || '—'}</span>
                <span>{formatDate(message.sent_at)}</span>
              </div>
              <div className={styles.messageText}>{message.text}</div>
              {message.outcome && (
                <div className={message.outcome.result === 'MATCHED' ? styles.ok : styles.muted} style={{ marginTop: '4px' }}>
                  {outcomeLabel(message.outcome.result)}
                  {message.outcome.detail ? ` — ${message.outcome.detail}` : ''}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </ModalDefault>
  );
};

export default MessagesModal;
